var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeature3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 295.238 295.238",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M295.238,102.381V64.287h-28.571V35.714h-47.619v28.571H76.19V35.714H28.571v28.571H0v38.095h19.048v152.381H0v38.095 h295.238v-38.095H276.19v-152.38H295.238z M285.714,264.286v19.048H9.524v-19.048h9.524H276.19H285.714z M266.666,254.762H28.571 V102.381h238.095V254.762z M276.189,92.858H19.048H9.524v-0.001V73.81h28.571V45.238h28.571V73.81h161.905V45.238h28.571V73.81 h28.571v19.048H276.189z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.476,
    y: 45.238,
    width: 114.286,
    height: 9.524
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.395,245.105l23.671-23.676h117.076v-9.524H149.59l47.619-47.619h-43.857l16.667-19.048h87.124v-9.524h-78.79 l8.333-9.524h-51.533l-4.762,9.524H38.095v9.524h87.533l-23.81,47.619h34.167l-7.414,19.771v-0.724H38.095v9.524h87.176 L116.395,245.105z M117.229,183.333l23.81-47.619h24.657l-33.333,38.095h41.857l-33.471,33.467l8.981-23.943H117.229z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.095,
    y: 11.906,
    width: 28.571,
    height: 9.524
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.095,30.953 247.619,30.953 247.619,21.43 257.143,21.43 257.143,11.906 247.619,11.906 247.619,2.381  238.095,2.381 238.095,11.906 228.571,11.906 228.571,21.43 238.095,21.43  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.095,
    y: 111.905,
    width: 9.524,
    height: 9.524
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.143,
    y: 111.905,
    width: 9.524,
    height: 9.524
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.095,
    y: 235.714,
    width: 9.524,
    height: 9.524
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.619,
    y: 111.905,
    width: 9.524,
    height: 9.524
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.571,
    y: 111.905,
    width: 9.524,
    height: 9.524
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature3);
export default __webpack_public_path__ + "static/media/feature-3.b7299c53ec5c3ef647cb7403147ed018.svg";
export { ForwardRef as ReactComponent };